// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__lM3uM","footer":"ReportModalFilter_footer__1lsvE"};